import { ItemTag } from "common/tag/dto/ItemTag";

export const CHARACTER_RELATE_CONTAIN_TAGS: ItemTag[] = [
  { title: "Character", value: "character" },
  { title: "Radical", value: "radical" },
];
